import ChestImage from '@shared/assets/images/v2/chest.svg';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import classNames from './PermissionError.module.css';

export function PermissionError() {
  const isDesktop = useIsDesktop();
  return (
    <View center flex>
      <ChestImage className={classNames.image} />
      <View paddingBottom={1}>
        <Text size={isDesktop ? 'h4' : 'subtitle'}>{i18n('errors.noAccess.heading')}</Text>
      </View>
      <View paddingBottom={4}>
        <Text size="body2">{i18n('errors.noAccess.subHeading')}</Text>
      </View>
    </View>
  );
}
